import axios from "axios";
import { supabase } from "../../config/supabaseClient";
import { UpdateCombinedText } from "./ContentDatabase";

export async function addToProductBank(
  post_id: any,
  name: any,
  url: any,
  image: any,
  user_id: any,
  query: any,
  username: any
) {
  // Example usage:
  let randomNumber = post_id;

  const { data, error } = await supabase.from("product_bank").insert([
    {
      name,
      url,
      image,
      query: `|${query}|`,
      user_id,
      product_id: randomNumber,
    },
  ]);

  if (error !== null) {
    let randomNumber = post_id;

    const { data, error } = await supabase.from("product_bank").insert([
      {
        name,
        url,
        image,
        query: `|${query}|`,
        user_id,
        product_id: randomNumber,
      },
    ]);
  }
  // return randomNumber;
  
  return randomNumber;
}

export async function updateProductBankQuery(
  ids: any,
  user_id: any,
  query: any,
  username: any
) {
  for (let i of ids) {
    if (!i.table_query?.replace(/\|/g, "")?.split(",").includes(query)) {
      i.table_query =
        i.table_query !== ""
          ? i.table_query + "," + "|" + query + "|"
          : "|" + query + "|";
    }
    const { data, error } = await supabase
      .from("product_bank")
      .update({ query: i.table_query })
      .eq("user_id", user_id)
      .eq("product_id", i.table_id)
      .eq("name", i.table_name);
    await supabase
      .from(username)
      .update({ metadata: i.table_query })
      .eq("user_id", user_id)
      .eq("post_id", i.table_id);
    // .eq("caption", i.table_name);
    UpdateCombinedText(username, user_id, i.table_id);
  }
}

export async function removeProductBankQuery(
  id: any,
  user_id: any,
  postData: any,
  query: any
) {
  let updatedData = postData.table_query
    ?.replace(/\|/g, "") // Remove all pipes
    .split(",") // Split by comma
    .filter((item: any) => {
      return item !== query;
    })
    .map((item: any) => `|${item}|`)
    .join(",");
  const { data, error } = await supabase
    .from("product_bank")
    .update({ query: updatedData })
    .eq("user_id", user_id)
    .eq("product_id", id);
}

export async function removeProductBank(
  id: any,
  user_id: any,
  postData: any,
  query: any
) {
  const { data, error } = await supabase
    .from("product_bank")
    .delete()
    .eq("user_id", user_id)
    // .eq("id", id)
    .eq("product_id", postData.table_id);
}

export async function removeProductBankName(
  id: any,
  user_id: any,
  postData: any,
  query: any
) {
  const { data, error } = await supabase
    .from("product_bank")
    .delete()
    .eq("user_id", user_id)
    // .eq("id", id)
    .eq("product_id", postData.table_product_id);
}

// export const extractProductUrl = (shoplink: string) => {
//   let cleanedUrl;

//   const uParamMatch = shoplink.match(/u=([^&]+)/);

// if (uParamMatch) {
//   // Case 1: URL has the 'u=' parameter
//   var encodedUrl = uParamMatch[1];
//   var decodedUrl = decodeURIComponent(encodedUrl);
//   const url = new URL(decodedUrl);
//   url.searchParams.delete("fbclid"); // Remove fbclid parameter
//   cleanedUrl = url.toString();
// } else {
//   // Case 2: Direct URL with fbclid
//   const url = new URL(shoplink);
//   url.searchParams.delete("fbclid"); // Remove fbclid parameter
//   cleanedUrl = url.toString();
// }
// return cleanedUrl;
// };

export function extractProductUrl(value: any) {
  let cleanedUrl = "";

  try {
    if (!value) {
      return ""; // Allow empty string or null/undefined
    }

    const uParamMatch = value.match(/u=([^&]+)/);

    if (uParamMatch) {
      const encodedUrl = uParamMatch[1];
      const decodedUrl = decodeURIComponent(encodedUrl);

      if (!decodedUrl.startsWith("http")) {
        throw new Error("Decoded URL is not valid: " + decodedUrl);
      }

      const url = new URL(decodedUrl);
      url.searchParams.delete("fbclid");
      cleanedUrl = url.toString();
    } else {
      if (!value.startsWith("http")) {
        throw new Error("Provided value is not a valid URL: " + value);
      }

      const url = new URL(value);
      url.searchParams.delete("fbclid");
      cleanedUrl = url.toString();
    }
  } catch (err) {
    console.error("URL cleanup failed:", err);
    return value;
  }

  return cleanedUrl;
}
